import React from 'react';

import Tooltip from '../Tooltip';
import LocationInfo from '../LocationInfo';
import Disclaimer from '../Disclaimer';

export default ({ statusDetail }) => (
  <article className="has-border-grey nbn-infobox__article content-area-white clearfix">
    <div className="one_half nbn-infobox__column">
      <div className="nbn-def-list">
        <dl className="has-margin-bottom-xsmall clearfix">
          <dt>Ready for Service <Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The date NBN switched on the first premises in this rollout area</p></Tooltip></dt>
          <dd>{ statusDetail.rfs_date ? statusDetail.rfs_date : 'Not available' }</dd>
        </dl>
        <dl className="has-margin-bottom-xsmall clearfix">
          <dt>Disconnection Date <Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">Existing phone and internet services delivered over Telstra's copper network will be switched off from this date</p></Tooltip></dt>
          <dd>{ statusDetail.disconnection_date ? statusDetail.disconnection_date : 'Not available' }</dd>
        </dl>
        <dl className="clearfix">
          <dt>Rollout Type <Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The NBN technology and rollout type of rollout used in this rollout area</p></Tooltip>
            <img src="https://dvh1deh6tagwk.cloudfront.net/finder-au/wp-uploads/2020/07/powered-by-nbn-lozenge.png" className="luna-image" alt="powered by nbn" />
          </dt>
          <dd>{ statusDetail.service_type_name }</dd>
        </dl>
        { statusDetail.recent_active
          ? <p className="text-center has-margin-bottom-xsmall line-height-medium"><small className="text-xxx-small fin-text-red">This area recently went active so we can't guarantee that a provider could connect you immediately.</small></p>
          : null }
      </div>
    </div>
    <div className="one_half nbn-infobox__column">
      <LocationInfo statusDetail={statusDetail} />
      <a href={`${window.location.origin}/broadband-plans`} className="btn btn-success weight-normal btn--fluid has-margin-bottom-xsmall">Compare Plans</a>
      { statusDetail.region_id
        ? <a href={`${window.location.origin}/nbn-tracker/rollout/${statusDetail.region_id}#details`} className="btn-link nbn-btn-link no-margin">More technical info here</a>
        : null
      }
    </div>
    <Disclaimer />
  </article>
);
